import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthenticationContext } from '../../../../application';
import AuthenticationLoadingState from '../molecules/AuthenticationLoadingState';
import { AUTH_TEXTS } from '../../../utils/texts';

interface ProtectedRouteProps {
  children: React.ReactNode;
  disallowedRoles?: string[];
  fallbackPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, disallowedRoles, fallbackPath = '/dashboard' }) => {
  const { isAuthenticated, isLoading, user } = useAuthenticationContext();

  if (isLoading) {
    return <AuthenticationLoadingState message={AUTH_TEXTS.authenticating} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  if (disallowedRoles && user && disallowedRoles.includes(user.role)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;